import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { viewProductCookies } from '../atoms/Header-Atoms'
import { useRecoilValue } from 'recoil';
import AlmondCookie from '../images/almond-cookie.png';
import ChocolateChipCookie from '../images/chocolate-chip-cookie.png';
import SourdoughChocolateChipCookie from '../images/sourdough-chocolate-chip-cookies.png';
import OatmealRaisinCookie from '../images/oatmeal-raisin-cookie.png';
import PeanutButterCookie from '../images/peanut-butter-cookie.png';
import DoubleChocolateCookie from '../images/double-chocolate-cookie.png';
import MaineOatmealCookie from '../images/maine-oatmeal-cookies.png';
import AlmondChocolateChip from '../images/almond-chocolate-chip.png';
import ToastedMilkCookie from '../images/toasted-milk-cookies.png';

function ProductCookies() {
    const enabled = useRecoilValue(viewProductCookies);

    return (
        <Fade in={enabled} timeout={{ enter: 400, exit: 400 }}>
            <div id="section-3" className="contentModule">
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={ToastedMilkCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Toasted Milk Cookie
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>A large cookie made with butter slowly browned and toasted with milk solids to create deep caramel and cereal-milk notes, then sweetened with real maple syrup for warmth rather than sweetness. Crisp at the edges, soft through the center, and rich without being overly sweet — a comforting, familiar cookie that pairs perfectly with coffee.</p>
                                        <p>Ingredients: Flour, Butter, Sugar, Brown Sugar, Nonfat Milk Powder, Maple Syrup, Egg, Salt, Baking Powder and Baking Soda.</p>
                                        <p>Price: $2 USD (per cookie, 6 cookie minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={SourdoughChocolateChipCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Sourdough Chocolate Chip Cookie
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Treat yourself to our bakery-style Sourdough Chocolate Chip cookies, designed to be soft, thick, and slightly chewy. Each cookie is baked to perfection, bursting with rich chocolate in every mouthful! While the name may suggest a tangy flavor, these cookies surprise with their mild sweetness and delightful taste, as the levain is used solely to enrich the flavor profile, making them truly special.</p>
                                        <p>Ingredients: Flour, Chocolate, Sugar, Brown Sugar, Butter, Egg, Maple Syrup, Salt, Baking Powder, Baking Soda and Rye Flour.</p>
                                        <p>Price: $3 USD (per cookie, 6 cookie minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={AlmondCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Almond Cookie
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>This seemingly unassuming cookie may appear to lack excitement at first glance, yet a single bite will quickly have you craving more. The cookies offer a delightful almond flavor complemented by a subtle sweetness, featuring a crisp outer layer and a tender, slightly chewy center.</p>
                                        <p>They are an excellent accompaniment to a refined cup of tea, robust dark coffee, or even a straightforward glass of milk.</p>
                                        <p>Ingredients: Flour, Sugar, Almonds, Butter, Cornstarch, Brandy and Milk.</p>
                                        <p>Price: $10 USD (12 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>                  
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={ChocolateChipCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Homestyle Chocolate Chip Cookie
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience a touch of nostalgia with these freshly baked, soft, sweet, and delectable cookies. Their delightful flavor endures even the following day, provided they are stored in an airtight container, maintaining their tender texture. These cookies embody all the qualities one anticipates from an exceptional chocolate chip cookie.</p>
                                        <p>Ingredients: Flour, Butter, Brown Sugar, Sugar, Eggs, Chocolate and Dark Chocolate, Maple Syrup, Baking Soda, Cornstarch and Salt.</p>
                                        <p>Price: $16 USD (12 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={OatmealRaisinCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Oatmeal Raisin Cookie
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>A timeless delight. Our freshly baked Oatmeal Raisin cookies feature a tender center and crisp edges. Bursting with plump, juicy raisins and hearty rolled oats, these simple cookies deliver an impressive flavor. Coated with powdered sugar and baked to perfection, they will undoubtedly leave you wanting more.</p>
                                        <p>Ingredients: Raisins, Rolled Oats, Flour, Sugar, Butter, Egg, Vegetable Shortening, Maple Syrup, Baking Soda, Salt, Molasses, Cinnamon and Baking Powder.</p>
                                        <p>Price: $2 USD (per cookie, 6 cookie minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    {/*
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={BakeryStyleGingerMolassesCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Bakery Style Ginger Molasses Cookie
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Featuring a chewy and soft consistency, these cookies are adorned with a crisp sugar coating. They present a sweet taste enriched by the warm spices of ginger and cloves. Those who appreciate ginger will find these cookies particularly enjoyable. While they will remain soft and chewy for a short duration, it is recommended to enjoy them within a few days.</p>
                                        <p>Ingredients: Flour, Butter, Sugar, Brown Sugar, Molasses, Egg, Baking Soda, Ginger, Cinnamon, Salt and Clove.</p>
                                        <p>Price: $2.50 USD (per cookie)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    */}
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={PeanutButterCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Peanut Butter Cookies
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>This isn’t your average peanut butter cookie—it’s a true peanut butter experience. Made with natural peanut butter, it delivers a rich, balanced sweetness that lets the real flavor shine without being over the top. Soft, tender, and just the right amount of chewy, each bite hits that perfect nostalgic-meets-elevated note.</p>
                                        <p>Ingredients: Flour, Natural Peanut Butter, Brown Sugar, Sugar, Butter, Cornstarch, Baking Soda, Baking Powder and Salt.</p>
                                        <p>Price: $2 USD (per cookie, 6 cookie minimum)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={DoubleChocolateCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Double Chocolate Chip Cookies
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Sink into a world of chocolate indulgence with our Double Chocolate Cookies—soft, rich, and irresistibly cocoa-packed in every bite. Crafted with smooth dark chocolate and studded with silky chocolate chunks, these cookies deliver the perfect balance of deep flavor and decadent sweetness. Enjoy them with a tall glass of milk or savor their deliciousness all on their own.</p>
                                        <p>Ingredients: Flour, Brown Sugar, Butter, Sugar, Cocoa Powder, Egg, Maple Syrup, Baking Soda and Salt.</p>
                                        <p>Price: $18 USD (12 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={MaineOatmealCookie}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Maine Oatmeal Crunchies
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>A cherished family recipe passed down from "Great Aunt Rete," who prepared these delightful cookies for special occasions. These small yet extraordinary cookies are infused with a delightful toffee-like flavor and baked to achieve a perfect crispness. The addition of pecans enhances the overall taste, although we can prepare them without if preferred. For those who are not fond of oatmeal cookies, these may very well alter your perspective. Conversely, if you are an admirer of oatmeal cookies, these will undoubtedly satisfy your cravings.</p>
                                        <p>Ingredients: Oats, Brown Sugar, Flour, Sugar, Vegetable Oil, Pecans ( optional ), Egg, Baking Soda, Salt and Maple Syrup.</p>
                                        <p>Price: $8 USD (12 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card sx={{ display: 'flex' }}>
                            <CardMedia
                                component="img"
                                sx={{ width: '25%' }}
                                image={AlmondChocolateChip}
                                alt=""
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column' }} className="cardContent">
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                    <Typography component="div" variant="h6">
                                        Almond Chocolate Chip Cookies
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" component="div">
                                        <p>Experience the unique flavor of these lightly sweet chocolate chip cookies made with almond flour. They feature a soft, chewy interior, a mix of sweet and dark chocolate, crispy edges and a classic cookie texture.</p>
                                        <p>Ingredients: Almond Flour, Dark Chocolate, Brown Sugar, Butter, Egg, Maple Syrup, Cornstarch, Baking Soda and Salt.</p>
                                        <p>Price: $16 USD (12 count)</p>
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        </Fade>      
    );
}

export default ProductCookies;